function injectStyle (ssrContext) {
  require("!!../node_modules/._extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../node_modules/._vue-loader@12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3de0e1b8\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/._vue-loader@12.2.2@vue-loader/lib/selector?type=styles&index=0!./App.vue")
}
var Component = require("!../node_modules/._vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/._vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../node_modules/._vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3de0e1b8\",\"hasScoped\":true}!../node_modules/._vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3de0e1b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 41
// module chunks = 1